module.exports = __webpack_public_path__ + "static/media/login.a878dd5e.png";